// Interview calls the BE rate-limits (/begin/, turn /edit/) answer 429 with a
// Retry-After header. The respondent never sees the throttle text; they see a
// calm "catching up" note while we wait it out and try once more.

export const RETRY_AFTER_DEFAULT_S = 5;
export const RETRY_AFTER_MAX_S = 30;

export const isRateLimited = (e) => e?.status === 429;

// Retry-After in ms: seconds from the header, the default when it's missing or
// unparseable, never more than the cap.
export const retryAfterMs = (e) => {
    const s = Number.parseFloat(e?.retryAfter);
    const secs = Number.isFinite(s) && s >= 0 ? s : RETRY_AFTER_DEFAULT_S;
    return Math.min(secs, RETRY_AFTER_MAX_S) * 1000;
};

// Run `call`; on a 429, call `onWait()`, wait out Retry-After, then run it once
// more. A non-429 failure, or the retry's own failure, rejects as-is.
export const withRateLimitRetry = async (call, { onWait } = {}) => {
    try {
        return await call();
    } catch (e) {
        if (!isRateLimited(e)) throw e;
        onWait && onWait();
        await new Promise((resolve) => setTimeout(resolve, retryAfterMs(e)));
        return call();
    }
};
